import Page from '@/features/dashboard/packages/pages/Package/Mobile'

export default Page
